export const isExternalLink = (to) => to.startsWith('http');
export const isEmailLink = (to) => to.startsWith('mailto:');
